import React, { useContext, useEffect, useState } from 'react'
import { UpdateEquipmentItem } from '../../components/Admin/UpdateEquipment/UpdateEquipmentItem';
import { VehicleContext } from '../../components/Context/VehicleContext';

const UpdateEquipment = () => {

  const {getVehicleData, getVehicleDescriptions, filteredVehicleData, searchText, setSearchText, numberFormatter, vehicleDescriptionModify} = useContext(VehicleContext);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value.toLowerCase());
  };

  return (
    <>
      <div className='container'>
        <div className='ad-black-box'>
          <div className='d-flex align-items-center justify-content-between mb-4'>
            <div className='md-title font-1-8em text-uppercase'>Update Equipment</div>
            <div className='ad-search-block d-flex align-items-center'>
              <input type='text' className='form-control' placeholder='Vehicle Search' value={searchText} onChange={handleSearchChange} />
            </div>
          </div>
          <UpdateEquipmentItem 
            getVehicleData={getVehicleData}
            getVehicleDescriptions={getVehicleDescriptions}
            filteredVehicleData={filteredVehicleData} 
            numberFormatter={numberFormatter}
            vehicleDescriptionModify={vehicleDescriptionModify}
            />
        </div>
      </div>
    </>
  )
}

export default UpdateEquipment